import React, { Component } from "react";

class CoatingRequisition extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div>
                Coating Requisition
            </div>
        );
    }
}

export default CoatingRequisition;
